export default {
    searchTerm: '',
    selectedFleet: '',
    numberVehiclesToInspect: 0,
    numberRequests: 0,
    extremeVehiculesInspectionCount: 0,
};



// WEBPACK FOOTER //
// ./src/store/state.js